import {Component, Input} from '@angular/core';
import {TranslatePipe} from "../../pipes/translate.pipe";

@Component({
    selector: 'app-form-label',
    imports: [
        TranslatePipe,
    ],
    templateUrl: './form-label.component.html',
    styleUrl: './form-label.component.scss'
})
export class FormLabelComponent {
  @Input() public label: string = '';
  @Input() public class: string = 'text-secondary';
  @Input() public maxChars: number = 0;
  @Input() public currentChars: number = 0;
  @Input() public type: 'top' | 'content' = 'top';

}
